var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91941 13.6329C3.01941 13.7329 3.14608 13.7795 3.27275 13.7795C3.39941 13.7795 3.52608 13.7262 3.62608 13.6329L7.97275 9.28619C8.31941 8.94619 8.50608 8.48619 8.50608 7.99952C8.50608 7.51286 8.31275 7.05286 7.97275 6.71286L3.62608 2.36619C3.43275 2.17286 3.11275 2.17286 2.91941 2.36619C2.72608 2.55952 2.72608 2.87952 2.91941 3.07286L7.26608 7.41952C7.58608 7.73952 7.58608 8.25952 7.26608 8.57952L2.91941 12.9262C2.72608 13.1195 2.72608 13.4395 2.91941 13.6329Z",
    fill: "#4B5565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25275 13.6329C8.35275 13.7329 8.47941 13.7795 8.60608 13.7795C8.73275 13.7795 8.85941 13.7262 8.95941 13.6329L13.3061 9.28619C13.6527 8.94619 13.8394 8.48619 13.8394 7.99952C13.8394 7.51286 13.6461 7.05286 13.3061 6.71286L8.95941 2.36619C8.76608 2.17286 8.44608 2.17286 8.25275 2.36619C8.05941 2.55952 8.05941 2.87952 8.25275 3.07286L12.5994 7.41952C12.9194 7.73952 12.9194 8.25952 12.5994 8.57952L8.25275 12.9262C8.05941 13.1195 8.05941 13.4395 8.25275 13.6329Z",
    fill: "#4B5565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowRight);
export default __webpack_public_path__ + "static/media/double-arrow-right.4c50ce4198737231a8aff064ed2b1f90.svg";
export { ForwardRef as ReactComponent };